import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IZipCodeRangeChecker } from '@shared/rangeChecker/IZipCodeRangeChecker';
import { NumericalZipCodeRangeChecker } from '@shared/rangeChecker/NumericalZipCodeRangeChecker';
import { StringZipCodeCodeRangeChecker } from '@shared/rangeChecker/StringZipCodeCodeRangeChecker';

export function ZipCodeToFromValidator(fromProperty: string, toProperty: string): ValidatorFn {
	return (group: AbstractControl): ValidationErrors | null => {
		const fromProp = group.get(fromProperty)?.value;
		const toProp = group.get(toProperty)?.value;

		if (!fromProp || !toProp) return null; // If either value is null, skip validation

		const from = Number.parseInt(fromProp, 10);
		const to = Number.parseInt(toProp, 10);
		let validator: IZipCodeRangeChecker;
		if (!Number.isNaN(from) || !Number.isNaN(to)) {
			validator = new NumericalZipCodeRangeChecker(from, to);
		} else if (typeof fromProp === 'string' && typeof toProp === 'string') {
			validator = new StringZipCodeCodeRangeChecker(fromProp, toProp);
		}

		if (validator && !validator.IsValidRange()) {
			return { invalidZipCodeRange: true };
		}
		return null;
	};
}
